<script>
  export let picture;
  export let link = null;
  export let youtube_id = null;

  //import Modal from 'svelte-simple-modal';
  //import ModalContentYT from './ModalContentYT.svelte';

  import { getContext, onMount } from "svelte";
  const { open } = getContext("simple-modal");
  import Video from "../widgets/Video.svelte";

  let el;
  onMount(() => {
    el.style.backgroundImage = `url(${picture})`;
  });

  const click = () => {
    if (link) window.open(link, "_blank").focus();
    if (youtube_id) {
      open(
        Video,
        { youtube_id: youtube_id, width: 853.3, autoplay: true },
        { styleWindow: { width: "53rem" } }
      );
    }
  };
</script>

<div class="character" on:click={click} bind:this={el} />

<style type="text/scss">
  .character {
    border-radius: 50%;
    width: 4vmax;
    height: 4vmax;
    transition: transform 0.05s ease-in-out;
    margin-right: 0.33em;
    cursor: pointer;

    background-size: cover;

    margin: 0.5em 0;

    &:hover {
      transform: scale(1.05);
    }
  }
</style>
